import styled from '@emotion/styled';
import { AnnouncementPanel } from '@innovamat/glimmer-components';
import { StyledBody, StyledSubtitle } from './styled-text';
import { TranslatorComponent } from './translator-component';

const PercentageSectionContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;

  @media screen and (max-width: ${(props) => props.theme.breakpoints.sm}) {
    flex-direction: column;
  }
`;

const Percentage = styled.div`
  display: flex;
  padding: 8px 0px;
  justify-content: center;
  align-items: center;
  gap: 8px;

  color: ${({ theme }) =>
    theme.tokens.color.specific['smart-guides']['part3-element'].value};
  font-size: 16px;
  font-weight: 600;
`;

const PercentageSectionTextContainer = styled.div`
  display: flex;
  padding: 8px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  flex: 1 0 0;
  border-left: 1px solid
    ${({ theme }) =>
      theme.tokens.color.specific['smart-guides']['part3-element'].value};
`;

type PercentageSectionProps = {
  announcementTranslationKey?: string;
  bodyTranslationKey: string;
  percentage: string;
  title?: string;
  titleKey?: string;
};

export const PercentageSection = ({
  announcementTranslationKey,
  bodyTranslationKey,
  percentage,
  title,
  titleKey,
}: PercentageSectionProps): JSX.Element => {
  return (
    <PercentageSectionContainer>
      <Percentage>{percentage}</Percentage>
      <PercentageSectionTextContainer>
        <StyledSubtitle>
          {titleKey ? <TranslatorComponent translationKey={titleKey} /> : title}
        </StyledSubtitle>
        <StyledBody>
          <TranslatorComponent translationKey={bodyTranslationKey} />
        </StyledBody>
        {announcementTranslationKey && (
          <AnnouncementPanel
            text={
              <TranslatorComponent
                translationKey={announcementTranslationKey}
              />
            }
            type="info"
            canClose={false}
          />
        )}
      </PercentageSectionTextContainer>
    </PercentageSectionContainer>
  );
};
